export enum BB_PAYMENT_PROVIDER_NAMES {
    STRIPE = "stripe",
    ADMIN = "admin",
    XSOLLA = "xsolla",
}